import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
//import dayjs from "dayjs"
//import { DATE_FORMAT } from "src/utils/constants"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakePrecosEventosFinanceirosPUPARTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch(err => {
            console.error("Error loading data:", err)
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": null,
            "DataReferencia": null,
            "DataEvento": null,
            "DataLiquidacao": null,
            "AmortizacaoOrdinariaPercentual": null,
            "AmortizacaoExtraordinariaPercentual": null,
            "IncorporacaoJurosPercentual": null,
            "ProjecaoIndicePreco": null,
            "CorrecaoInflacaoAnual": null,
            "DataAniversario": null,
            "VN": null,
            "VNA": null,
            "AtualizacaoMonetaria": null,
            "AmortizacaoOrdinaria": null,
            "AmortizacaoExtraordinaria": null,
            "Juros": null,
            "IncorporacaoJuros": null,
            "Pagamento": null,
            "TaxaVF_Acum": null,
            "TaxaVP_Acum": null,
            "PercentualAmortizado": null,
            "IncorporacaoJurosTotal": null,
            "DataEventoProximo": null,
            "ValorFuturo": null,
            "LOGERRO": null,
            "JurosAcruados": null,
            "ValorProximoEvento": null,
            "JurosIncremento": null,
            "PremioPago": null,
            "PremioFuturo": null,
            "ParceladasCanceladasTotal": null,
            "DataEventoAnterior": null,
            "ValorEventoAnterior": null,
            "DataAniversarioAnterior": null,
            "DataIndicador": null
        }

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            console.error("Error creating row:", err)
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CETIP, DataReferencia, DataEvento, DataLiquidacao,
AmortizacaoOrdinariaPercentual,
AmortizacaoExtraordinariaPercentual,
IncorporacaoJurosPercentual,
ProjecaoIndicePreco,
CorrecaoInflacaoAnual,
DataAniversario,
VN,
VNA,
VNA_PUPAR,
VNA_PUMTM,
AtualizacaoMonetaria,
AtualizacaoMonetariaPUPAR,
AtualizacaoMonetariaPUMTM,
AmortizacaoOrdinaria,
AmortizacaoExtraordinaria,
Juros,
IncorporacaoJuros,
Pagamento,
TaxaVF_Acum,
TaxaVP_Acum,
PercentualAmortizado,
IncorporacaoJurosTotal,
DataEventoProximo,
ValorFuturo,
LOGERRO,
JurosAcruados,
ValorProximoEvento,
JurosIncremento,
PremioPago,
PremioFuturo,
ParceladasCanceladasTotal,
DataEventoAnterior,
ValorEventoAnterior,
DataAniversarioAnterior,
DataIndicador
  } = newRow

        const body = {
            "CETIP": CETIP,
            "DataReferencia": DataReferencia,
            "DataEvento": DataEvento,
            "DataLiquidacao": DataLiquidacao,
            "AmortizacaoOrdinariaPercentual": AmortizacaoOrdinariaPercentual,
            "AmortizacaoExtraordinariaPercentual": AmortizacaoExtraordinariaPercentual,
            "IncorporacaoJurosPercentual": IncorporacaoJurosPercentual,
            "ProjecaoIndicePreco": ProjecaoIndicePreco,
            "CorrecaoInflacaoAnual": CorrecaoInflacaoAnual,
            "DataAniversario": DataAniversario,
            "VN": VN,
            "VNA": VNA,
            "VNA_PUPAR": VNA_PUPAR,
            "VNA_PUMTM": VNA_PUMTM,
            "AtualizacaoMonetaria": AtualizacaoMonetaria,
            "AtualizacaoMonetariaPUPAR": AtualizacaoMonetariaPUPAR,
            "AtualizacaoMonetariaPUMTM": AtualizacaoMonetariaPUMTM,
            "AmortizacaoOrdinaria": AmortizacaoOrdinaria,
            "AmortizacaoExtraordinaria": AmortizacaoExtraordinaria,
            "Juros": Juros,
            "IncorporacaoJuros": IncorporacaoJuros,
            "Pagamento": Pagamento,
            "TaxaVF_Acum": TaxaVF_Acum,
            "TaxaVP_Acum": TaxaVP_Acum,
            "PercentualAmortizado": PercentualAmortizado,
            "IncorporacaoJurosTotal": IncorporacaoJurosTotal,
            "DataEventoProximo": DataEventoProximo,
            "ValorFuturo": ValorFuturo,
            "LOGERRO": LOGERRO,
            "JurosAcruados": JurosAcruados,
            "ValorProximoEvento": ValorProximoEvento,
            "JurosIncremento": JurosIncremento,
            "PremioPago": PremioPago,
            "PremioFuturo": PremioFuturo,
            "ParceladasCanceladasTotal": ParceladasCanceladasTotal,
            "DataEventoAnterior": DataEventoAnterior,
            "ValorEventoAnterior": ValorEventoAnterior,
            "DataAniversarioAnterior": DataAniversarioAnterior,
            "DataIndicador": DataIndicador
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            console.error("Error updating row:", err)
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            console.error("Error deleting row:", err)
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch(err => {
            console.error("Error filtering data:", err)
            props.loading(false)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        }).catch(err => {
            console.error("Error changing page:", err)
            props.loading(false)
        })
    }

    const columns = [
        { field: 'ID', headerName: '#', disableColumnMenu: true, disableFilter: true, flex: true, minWidth: 80 },
        { field: 'CETIP', headerName: 'CETIP', flex: 1, minWidth: 150, maxWidth: 350, disableColumnMenu: true, editable: true },
        { field: 'DataReferencia', headerName: 'DataReferencia', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'DataEvento', headerName: 'DataEvento', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'DataLiquidacao', headerName: 'DataLiquidacao', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'AmortizacaoOrdinariaPercentual', headerName: 'AmortizacaoOrdinariaPercentual', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'AmortizacaoExtraordinariaPercentual', headerName: 'AmortizacaoExtraordinariaPercentual', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'IncorporacaoJurosPercentual', headerName: 'IncorporacaoJurosPercentual', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'ProjecaoIndicePreco', headerName: 'ProjecaoIndicePreco', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'CorrecaoInflacaoAnual', headerName: 'CorrecaoInflacaoAnual', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'DataAniversario', headerName: 'DataAniversario', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'VN', headerName: 'VN', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'VNA_PUPAR', headerName: 'VNA_PUPAR', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'VNA_PUMTM', headerName: 'VNA_PUMTM', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'AtualizacaoMonetariaPUPAR', headerName: 'AtualizacaoMonetariaPUPAR', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'AtualizacaoMonetariaPUMTM', headerName: 'AtualizacaoMonetariaPUMTM', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'AmortizacaoOrdinaria', headerName: 'AmortizacaoOrdinaria', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'AmortizacaoExtraordinaria', headerName: 'AmortizacaoExtraordinaria', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'Juros', headerName: 'Juros', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'IncorporacaoJuros', headerName: 'IncorporacaoJuros', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'Pagamento', headerName: 'Pagamento', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'TaxaVF_Acum', headerName: 'TaxaVF_Acum', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'TaxaVP_Acum', headerName: 'TaxaVP_Acum', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'PercentualAmortizado', headerName: 'PercentualAmortizado', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'IncorporacaoJurosTotal', headerName: 'IncorporacaoJurosTotal', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'DataEventoProximo', headerName: 'DataEventoProximo', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'ValorFuturo', headerName: 'ValorFuturo', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'LOGERRO', headerName: 'LOGERRO', flex: 1, minWidth: 150, maxWidth: 350, disableColumnMenu: true, editable: true },
        { field: 'JurosAcruados', headerName: 'JurosAcruados', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'ValorProximoEvento', headerName: 'ValorProximoEvento', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'JurosIncremento', headerName: 'JurosIncremento', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'PremioPago', headerName: 'PremioPago', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'PremioFuturo', headerName: 'PremioFuturo', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'ParceladasCanceladasTotal', headerName: 'ParceladasCanceladasTotal', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'DataEventoAnterior', headerName: 'DataEventoAnterior', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'ValorEventoAnterior', headerName: 'ValorEventoAnterior', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'number', type: 'number', disableColumnMenu: true, editable: true },
        { field: 'DataAniversarioAnterior', headerName: 'DataAniversarioAnterior', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'DataIndicador', headerName: 'DataIndicador', flex: 1, minWidth: 150, maxWidth: 350, typeComponent: 'date', disableColumnMenu: true, editable: true },
        { field: 'CriadoEm', headerName: 'Data de Criação', flex: true, minWidth: 150, disableColumnMenu: true, renderCell: params => formatDateDataGrid(params) },
        { field: 'AtualizadoEm', headerName: 'Data de Atualização', flex: true, minWidth: 150, disableColumnMenu: true, renderCell: params => formatDateDataGrid(params) }
        ]


    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakePrecosEventosFinanceirosPUPARTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakePrecosEventosFinanceirosPUPARTable
